import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top immediately when path changes
    // Use both methods to ensure compatibility across browsers
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Use 'instant' for immediate scroll, 'smooth' for animated
    });
    
    // Fallback for older browsers
    if (window.scrollTo) {
      window.scrollTo(0, 0);
    }
    
    // Also try scrolling the document element
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    
    if (document.body) {
      document.body.scrollTop = 0;
    }
  }, [pathname]);

  return children || null;
};

export default ScrollToTop;
